import {DateTime} from "luxon";

export function zIndexReverse(total, index) {
    let style = 'z-index: ' + ((10 + total) - index) + ';';

    if (total / (index + 1) === 2) {
        style += 'padding-right: 70px;';
    }

    return style;
}

export function formatDate(value, fmt = 'dd-LL-yyyy', fallback = '') {
    if (!value) return fallback;
    let dt = value;
    if (!DateTime.isDateTime(dt)) {
        const s = String(value);
        dt = DateTime.fromISO(s);
        if (!dt.isValid) dt = DateTime.fromFormat(s, 'yyyy-LL-dd HH:mm:ss');
        if (!dt.isValid) dt = DateTime.fromFormat(s, this.datePathFormat);
    }
    return dt && dt.isValid ? dt.toFormat(fmt) : fallback;
}

export function formatAtDayBoundary(ts, edge = 'start', opts = {}) {
    const { zone = 'local', outFormat = 'yyyy-LL-dd HH:mm:ss' } = opts;

    if (!ts) return '';

    // Parse ISO first (handles Z/offset + microseconds), then fallback to SQL.
    let dt = DateTime.isDateTime(ts)
        ? ts
        : DateTime.fromISO(String(ts), { setZone: true });
    if (!dt.isValid) dt = DateTime.fromSQL(String(ts), { setZone: true });
    if (!dt.isValid) return String(ts);

    // Choose zone for output
    if (zone === 'local') dt = dt.toLocal();
    else if (zone === 'utc') dt = dt.toUTC();
    // 'keep' leaves the original zone

    // Snap to day edge
    const t = (edge === 'end')
        ? { hour: 23, minute: 59, second: 59, millisecond: 0 }
        : { hour: 0, minute: 0, second: 0, millisecond: 0 };

    return dt.set(t).toFormat(outFormat);
}

// Aliases without the "sql" prefix
export function startOfDay(ts, opts) { return this.formatAtDayBoundary(ts, 'start', opts); }
export function endOfDay(ts, opts)   { return this.formatAtDayBoundary(ts, 'end', opts); }

export function formatCreated(sqlTs) {
    if (!sqlTs) return '';
    // Parse ISO like 2025-07-25T09:54:48.000000Z
    let dt = DateTime.fromISO(String(sqlTs), { setZone: true });
    // Fallback if backend sometimes sends SQL-style timestamps
    if (!dt.isValid) dt = DateTime.fromSQL(String(sqlTs), { setZone: true });

    // Display in the user's local time; use .toUTC() instead if you want UTC.
    return dt.isValid ? dt.toLocal().toFormat('dd-LL-yyyy HH:mm:ss') : String(sqlTs);
}

export function stripIdentPrefix(ident) {
    if (ident == null) return '';
    return String(ident).replace(/^(?:sales|service)_/i, '');
}

// Escape regex metacharacters so idents don't break your pattern
export function escapeRegex(s) {
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function patternFromIdents(identOrArray, { stripPrefix = true } = {}) {
    const arr = Array.isArray(identOrArray) ? identOrArray : [identOrArray];
    const parts = arr
        .map(v => v == null ? '' : String(v))
        .map(v => stripPrefix ? stripIdentPrefix(v) : v)
        .map(v => v.trim())
        .filter(Boolean)
        .map(escapeRegex);

    if (!parts.length) return '';
    return parts.join('|'); // plain OR regex (no anchors)
}